import { ActionIcon, Tooltip } from '@mantine/core';
import { useDrawerContext } from 'context/hooks';
import { LogsList } from 'models/patientMedicalEvent';
import { LogDetailsDrawer } from 'pages/Main/Patients/Details/Overview/HeartRateOverview/LogsOverview/LogDetailsDrawer';
import { useTranslation } from 'react-i18next';
import { BsClipboard2Pulse } from 'react-icons/bs';

interface Props {
  log: LogsList;
}

export const LogDetailsActionIcon = ({ log }: Props) => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();

  return (
    <>
      <Tooltip label={t('details_title')}>
        <ActionIcon
          onClick={() => openDrawer({ content: <LogDetailsDrawer log={log} /> })}
          variant={'outline'}
          size={'sm'}
        >
          <BsClipboard2Pulse color={'var(--mantine-color-blue-5)'} size={16} />
        </ActionIcon>
      </Tooltip>
    </>
  );
};
